<div *ngIf="showLoading">
  <div style="min-height: 60px">
    <div class="centerLoader">
      <svg class="circular" viewBox="25 25 50 50">
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </svg>
    </div>
  </div>
  <div *ngIf="messageToDisplay" style="text-align: center">
    <div style="width: 150px !important" class="centerLoader">
      <b>{{ messageToDisplay }}</b>
    </div>
  </div>
</div>
